<template>
    <div>
        <div >
            <div class="flex jcsb" >
                <div>{{offerData.title}}</div>
                <el-button class="marB10 hfc" @click="lookreport" :class="baseerp+'btn'" size="mini" >
                    查看报表
                </el-button>
            </div>
            <div class="flex mrt10 fs" >
            <el-form label-width="95px" size="mini" :inline="true">
                    <el-form-item class="form-title" label="截止日期">
                        <div style="width: 100px">{{offerData.duetime}}</div>
                    </el-form-item>
                    <el-form-item class="form-title" label="报价公司">
                        <el-select style="width: 200px" @change="offerlist('gs')" v-model="i_khid" size="mini" placeholder="报价公司" filterable clearable>
                            <el-option

                                    v-for="item in companyList"
                                    :key="item.i_id"
                                    :label="item.name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title"  label="招标品种" >
                        <el-select style="width: 200px" @change="offerlist('pz')"  v-model="i_pzid" size="mini" placeholder="招标品种" filterable clearable>
                            <el-option

                                    v-for="item in pzList"
                                    :key="item.i_id"
                                    :label="item.name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                    </el-form-item>

            </el-form>
            <el-button class="marB10 hfc" @click="stop" :class="baseerp+'btn'" size="mini" v-if="offerData.i_open_able==1&&offerData.i_hasOpenRight==1" :disabled="flow">
                开标
            </el-button>
            </div>
            <!--<el-button class="marB10"  @click="notchoose" :class="baseerp+'btn'" size="mini" v-if="titleData.state==2">
                流标
            </el-button>-->
        </div>
        <el-table
                class="mrt10"
                ref="table"
                size="mini"
                row-key="id"
                :height="tableHeight"
                border
                :data="tableData"
                :header-cell-style="{background:'#fbfcfd',color:'#000'}"
                @selection-change="handleSelectionChange"
                :highlight-current-row="true"
                :row-class-name="tableRowClassName"
                style="width: 100%">
                <el-table-column type="selection" width="55" :selectable="selectable" :reserve-selection="true">
                </el-table-column>
                <el-table-column :label="$t('form_serial_number')" align="center" width="50" type="index" show-overflow-tooltip>
                </el-table-column>
                <el-table-column align="center" label="状态" width="90px" prop="stateTxt" show-overflow-tooltip>
                </el-table-column>
                <el-table-column align="center" label="品种大类" prop="pzPName" show-overflow-tooltip>
                </el-table-column>
                <el-table-column align="center"  :label="$t('form_product_name')" prop="pzName" show-overflow-tooltip>
                </el-table-column>
                <el-table-column  align="center" label="规格" prop="specification" show-overflow-tooltip>
                </el-table-column>
                <el-table-column align="center" label="报价人"  sortable prop="vc_lruname" show-overflow-tooltip>
                </el-table-column>
                <el-table-column align="center" label="报价公司" sortable prop="vc_khname" show-overflow-tooltip>
                </el-table-column>
                <el-table-column align="center" label="报价(元)" sortable prop="f_price" show-overflow-tooltip>
                </el-table-column>
                <el-table-column align="center" label="需求数量" prop="num" show-overflow-tooltip>
                </el-table-column>
                <el-table-column align="center" label="投标数量" prop="f_offernum" show-overflow-tooltip>
                </el-table-column>
                <el-table-column align="center" label="中标数量"  prop="f_successnum">
                    <template slot-scope="scope" v-if="offerData.i_res_id==0">
                        <el-input-number v-model="scope.row.f_successnum" style="width: 100%" @change="changeZbNum(scope.row,scope.$index)" clearable size="mini" :controls="false" :min="0" ></el-input-number>
                    </template>
                </el-table-column>
<!--                        <template  slot-scope="scope">-->
<!--                    <el-table-column-->
<!--                            v-if="type==2"-->
<!--                            align="center"-->
<!--                            label="提货时间"-->
<!--                            sortable-->
<!--                            prop="takeTime" show-overflow-tooltip>-->
<!--                    </el-table-column>-->
<!--                    <el-table-column-->
<!--                            v-if="type==1"-->
<!--                            align="center"-->
<!--                            label="到货时间"-->
<!--                            sortable-->
<!--                            prop="takeTime" show-overflow-tooltip>-->
<!--                    </el-table-column>-->
<!--                        </template>-->

                <el-table-column align="center" label="报价时间" sortable prop="dt_createtime" show-overflow-tooltip>
                </el-table-column>
                <el-table-column align="center" :label="$t('form_notes')" prop="vc_offernote" show-overflow-tooltip>
                </el-table-column>
                <el-table-column align="center" label="附件" >
                    <template slot-scope="scope" v-if="scope.row.vc_offerfiles">
                        <a
                                :download="scope.row.vc_offerfiles.vc_name"
                                mce_href="#"
                                :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+scope.row.vc_offerfiles.vc_newname+',tenderapp\'}','utf-8')">
                            <!--:herf="file"-->     {{scope.row.vc_offerfiles.vc_name}}
                        </a>
                    </template>

                </el-table-column>
        </el-table>
        <el-pagination
                style="text-align: right;"
                class="fr page"
                background
                layout="prev, pager, next"
                @current-change="pageCurrentChange"
                :current-page.sync="currentPage"
                :total="tableTotal"
                :page-size="pageSize">
        </el-pagination>
        <div class="center">
            <el-button type="primary" @click="confirm" :disabled="flow" :class="baseerp+'btn'" size="small" v-if="offerData.state==4&&!offerData.i_res_id">中标</el-button>
            <el-button @click="goback" size="mini">取 消</el-button>

        </div>
        <div :class="baseerp+'div'">
            <el-dialog title="确认报价"
                       :class="baseerp+'div'"
                       width="90%"
                       :visible.sync="confirmdialog"
                       :close-on-click-modal="false"
                       :append-to-body="true">
                <confirm-offer :confirmData="confirmData" @close="closeConfirm"  v-if="confirmdialog" @bidsList="refresh"></confirm-offer>
            </el-dialog>
        </div>
<!--        <div class="contentLeft">-->
<!--            <reportdialog  ref="mydialog"  :append-to-body="true" ></reportdialog>-->
<!--            <eDialog ref="eDialog" :activePage="activePage" :append-to-body="true"></eDialog>-->
<!--        </div>-->
    </div>
</template>

<script>
    import * as API from "../../api"
    import {mapActions} from "vuex";
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    import ConfirmOffer from "./ConfirmOffer";
    import reportdialog from "@/components/dialog"; // dialog
    import eDialog from "@/components/eDialog"; // dialog
    export default {
        name: "OfferList",
        components:{ConfirmOffer,reportdialog,eDialog},
        props:{
            offerData:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                i_khid:'',
                i_pzid:'',
                baseerp:'',
                search:'',
                pageSize:20,
                currentPage:1,
                tableTotal:0,
                activePage:"report/res/spread.vue",
                confirmdialog:false,
                tableData:[],
                tableHeight:0,
                mid:0,
                rowList:[],
                titleData:'',
                data:[],
                type:1,
                flow:false,
                disfail:false,
                arr:[],
                dialogVisible:false,
                companyList:[],
                pzList:[],
                confirmData:{},
                chooseKb:[],
                token:'',
                i_uid:'',
                file_url: '',
                baseApp:"",
                baseVersion:"",
            }
        },
        watch:{
            offerData:{
                handler(){
                },
                immediate:true,
                deep:true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        mounted() {

            this.baseerp=baseerp;
            this.token=sessionStorage.getItem("token");
            this.i_uid= sessionStorage.getItem("userid");
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.$nextTick(()=>{
                this.onResize();
            })
            this.offerlist();
            this.subIds();
            this.getKhsByBid();
            this.listPzsByBid();
        },
        activated(){
            this.onResize();
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h*0.5
                if(this.tableHeight<60)this.tableHeight=60
            },
            goback(){
                this.$emit('close',this.back)
            },
            tableRowClassName({row}){
                // console.log(row.i_ismin,'row.i_ismin')
                if(row.i_ismin==1){
                    return 'success'
                }else{
                    return ''
                }
            },
            refresh(type='',id=0){
                this.$emit('bidsList')
                if(type=='close'){
                    this.goback()
                }else  if(type=='save'){
                    this.offerData.i_res_id=id
                }
            },
            changeZbNum(row,index){
                this.$nextTick(()=>{
                    if(row.f_successnum>row.f_offernum){
                        this.$message.warning('中标量不得大于投标量');
                        this.tableData[index].f_successnum=row.f_offernum;
                        this.$forceUpdate()
                    }else{
                        // this.chooseKb.map(kb=>{
                        //     if(row.id==kb.id){
                        //         kb.f_successnum=row.f_successnum
                        //     }
                        // });
                    }
                    this.chooseKb.map(kb=>{
                        if(row.id==kb.id){
                            kb.f_successnum=row.f_successnum
                        }
                    });
                    this.$forceUpdate()

                })
            },
            async getKhsByBid(){
                let param={
                    i_id:this.offerData.id
                };
                let res=await API.getKhsByBid(param);
                if ( res.code == 1 ){
                    this.companyList=res.data
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async subIds(){
                let param={
                    i_id:this.offerData.id
                };
                let res=await API.subIds(param);
                if ( res.code == 1 ){
                    this.subIdList=res.data
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async listPzsByBid(){
                let param={
                    i_id:this.offerData.id
                };
                let res=await API.listPzsByBid(param);
                if ( res.code == 1 ){
                    this.pzList=res.data
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async offerlist(type=''){
                if(type=='gs'||type=='pz'){
                    this.currentPage=1
                    this.$refs.table.clearSelection()
                }
                let param={
                    i_id:this.offerData.id,
                    i_khid:this.i_khid,
                    i_pzid:this.i_pzid,
                    pageSize:this.pageSize,
                    currentPage:this.currentPage,
                };
                let res=await API.offerlist(param);
                if ( res.code == 1 ){
                    this.tableData=res.data.list;
                    this.tableTotal=res.data.total;
                    if(this.chooseKb.length>0){
                        this.tableData.map(t=>{
                            let obj=this.chooseKb.find(kb=>kb.id==t.id);
                            if(obj!=undefined){
                                t.f_successnum=obj.f_successnum
                            }
                        })
                    }

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async stopBid(){
                this.flow=true
                let param={
                    i_id:this.offerData.id,
                };
                let res=await API.stopBid(param);
                if ( res.code == 1 ){
                   this.$message.success(res.message)

                    this.offerData.state=4
                    this.flow=false
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                    this.flow=false
                }else{
                    this.$message.error(res.message);
                    this.flow=false
                }
            },
            stop(){
                this.$confirm('开标后将不能继续投标,是否继续开标','提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(async()=>{
                    this.stopBid()
                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:'已取消'
                    })
                })
            },
            selectable(row){
                if(row.i_state==-2){
                    return false
                }else {
                    return true

                }
            },
            handleSelectionChange(val){
                this.chooseKb=val

            },

            closeConfirm(){
                this.confirmdialog=false
            },
            confirm(){
                // console.log('this.chooseKb',this.chooseKb)
                if (this.chooseKb.length>0){
                    let cans=true
                    for (let i=0;i<this.chooseKb.length;i++){
                        this.chooseKb[i].i_type=1;
                        if(this.chooseKb[i].f_successnum==0){
                            cans=false
                            this.$message.warning('中标数量不得为0');
                        }
                    }
                    if (!cans)return
                    this.handleChooose()
                }else{
                    this.$confirm('没有选择中标产品,是否确认','提示',{
                        confirmButtonText:'继续',
                        cancelButtonText:'取消',
                        type:'warning'
                    }).then(()=>{
                        this.handleChooose()
                    }).catch(()=>{
                        this.$message({
                            type:'info',
                            message:'已取消'
                        })
                    })
                }



            },
            handleChooose(){
                // let noSelect=[...this.pzList].filter(sg=>[...this.chooseKb].every(ap=>sg.i_id!==ap.pzId)),
                let noSelect=[...this.subIdList].filter(sg=>[...this.chooseKb].every(ap=>sg.i_req_subid!==ap.i_req_subid)),
                    nerarr=[];
                noSelect.map(pz=>{
                    let hash={
                        pzName:pz.pzName,
                        pzPName:pz.pzPName,
                        pzId:pz.pzId,
                        specification:pz.specification,
                        noselect:true,
                        i_type:null,
                        i_req_subid:pz.i_req_subid,
                        num:pz.num,
                    }
                    // let hash={
                    //     pzName:pz.name,
                    //     pzPName:pz.pzPName,
                    //     pzId:pz.i_id,
                    //     specification:pz.model,
                    //     noselect:true,
                    //     i_type:null,
                    //     i_req_subid:pz.i_req_subid,
                    //     num:pz.num,
                    // }
                    nerarr.push(hash)
                })
                this.confirmData={
                    id:0,
                    i_id:this.offerData.id,
                    i_gid:this.offerData.i_gid,
                    gsId:this.offerData.gsId,
                    offers:[...this.chooseKb,...nerarr],
                }
                this.confirmdialog=true;
            },
            //明细报表
            lookreport() {
                this.$emit('look')
                // let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});
                //
                // this.$refs.eDialog.showDialog({title:"报价明细结果报表",parm:{type:'RequireOfferRpt',mid:this.$route.meta.mid,arg:{i_bid_id:this.offerData.id}},w:1024,h:768});
                // loading.close();
                // document.addEventListener('click',function(e){
                //     loading.close()
                // });
                    // console.log(res)
            },

            async flowSub(item){
                this.flow=true
                this.$message.success('正在提交，请稍候')
                let param={
                    id:this.formData.id,
                    i_id:this.formData.id,
                    createTime:this.formData.createTime,
                    creatorTime:this.formData.creatorTime,
                    table:this.formData.table,
                    creatorId:this.formData.creatorId,
                    busType:this.formData.busType,
                    validateCode:this.formData.validateCode,
                    validateKeynames:this.formData.validateKeynames,
                };
                let res=await API.flowSub(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('refresh')
                    this.cancel()
                    this.flow=false
                }else if (res.code == -2) {
                    this.flow=false

                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.flow=false
                    this.$message.error(res.message);
                }
            },

            //分页
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.offerlist()
            },
            addclose(){
                this.dialogTableVisible=false;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .success{
        background: #f0f9eb;
    }
    .hfc{
        height: fit-content;
    }
    .mrt10{
        margin-top: 10px;
    }
    .fs{
        align-items: flex-start;
    }
    .mrl10{
        margin-left: 10px;
    }
    .mrA{
        margin-top: auto;
        margin-bottom: auto;
    }
    .flex{
        display: flex;

    }
    .jcsb{
    justify-content: space-between
    }
    .center{
        text-align: center;
    }
/deep/{
    .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
    }
    .el-dialog{
        min-width: 420px;
    }
    .el-input-number--mini{
        width: 80px;
    }
    .success{
        background: #f0f9eb;
    }
    .el-input-number.is-without-controls .el-input__inner{
        padding-left: 0px;
        padding-right: 0px;
    }
    .el-table__expand-icon{
        display: none;
    }
    .el-table__expanded-cell[class*=cell]{
        padding: 5px;
    }
}
</style>